"use client";

import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
const packages = [{
  id: 1,
  title: "Junior Academy",
  description: "Foundational development for MiniRoos and SAP players. Focus on technical skills and team spirit.",
  popular: false
}, {
  id: 2,
  title: "Elite Pathway",
  description: "High-performance training for JPL and Senior squads. Professional coaching and tactical analysis.",
  popular: true
}, {
  id: 3,
  title: "Senior Premier",
  description: "The pinnacle of Birkalla football. Full access to elite facilities, medical staff, and match kits.",
  popular: false
}];
const features = [{
  packageId: 1,
  text: "2 Weekly Training Sessions"
}, {
  packageId: 1,
  text: "Official Birkalla Training Kit"
}, {
  packageId: 1,
  text: "MiniRoos Match Fees"
}, {
  packageId: 1,
  text: "End of Season Trophy"
}, {
  packageId: 2,
  text: "3 Weekly Elite Sessions"
}, {
  packageId: 2,
  text: "Video Analysis Access"
}, {
  packageId: 2,
  text: "Strength & Conditioning"
}, {
  packageId: 2,
  text: "Early Bird Discount"
}, {
  packageId: 3,
  text: "Daily Training Access"
}, {
  packageId: 3,
  text: "Physiotherapy Support"
}, {
  packageId: 3,
  text: "Home & Away Match Kits"
}, {
  packageId: 3,
  text: "Business Network Entry"
}];
export default function ForfaitsSurMesure() {
  return <section data-section-id="223335" id="training-investment" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <Badge variant="outline" className="mb-6 rounded-none bg-primary/10 text-primary border-primary/50 px-4 py-1.5 text-xs font-default font-bold tracking-widest uppercase">
            Season Fees
          </Badge>
          <h2 className="text-4xl md:text-5xl font-default font-bold mb-6 text-foreground uppercase tracking-tighter">
            Invest in Your Football Future at Birkalla
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Transparent pricing for elite development across all age groups and skill levels.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-start">
          {packages.map((pkg, i) => <div data-index={i} key={pkg.id} className="relative h-full">
              <Card className={`h-full flex flex-col bg-card border-t-2 ${pkg.popular ? "border-primary shadow-2xl shadow-primary/5" : "border-border/50"} rounded-none p-8 relative overflow-visible`}>
                {pkg.popular && <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                    <span className="bg-primary text-primary-foreground text-xs font-default font-bold px-4 py-1.5 rounded-none shadow-md whitespace-nowrap uppercase tracking-wider">
                      Early Bird Special
                    </span>
                  </div>}

                <div className="mb-8">
                  <h3 className="text-2xl font-default font-bold text-foreground mb-4 uppercase tracking-tight">
                    {pkg.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed font-default">
                    {pkg.description}
                  </p>
                </div>

                <ul className="space-y-4 mb-8 flex-grow">
                  {features.filter(f => f.packageId === pkg.id).map((feature, j) => <li data-index={j} key={j} className="flex items-start gap-3">
                        <Check className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <span className="text-muted-foreground text-sm font-default">
                          {feature.text}
                        </span>
                      </li>)}
                </ul>

                <div className="mt-auto pt-8">
                  <Button asChild variant="outline" className="w-full rounded-none border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-300 py-6 text-base group font-default font-bold uppercase tracking-widest">
                    <Link to="/GetInTouchPage">
                      Register Now
                      <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                    </Link>
                  </Button>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}